<app-header></app-header>
<br />
<div class="mobile-author-actions"></div>

<div class="container">
  <div class="container-fluid">
    <div class="social-dash-wrap">
      <div class="row">
        <div class="card">
          <div class="card-body">
            <div class="info-section">
              <h3>Why Data Brokers Have Your Info</h3>
              <p>
                Ever searched your name online and found your home address,
                phone number, or even the names of your family members? You're
                not imagining things. <b>Data brokers</b> are behind this — and
                here’s why they have your information.
              </p>
            </div>
            <div class="info-section">
              <h5>🕵️‍♂️ Who Are Data Brokers?</h5>
              <p>
                Data brokers are companies that
                <b>collect, buy, and sell personal information about people</b>
                — often without direct interaction or consent. Their business
                model relies on gathering as much data as possible and turning
                it into detailed personal profiles.
              </p>
              <p>These profiles are then sold to:</p>
              <ul>
                <li>Advertisers and marketers</li>
                <li>Background check services</li>
                <li>People search websites</li>
                <li>Credit scoring companies</li>
                <li>Insurance firms</li>
                <li>Political campaigners — and more</li>
              </ul>
            </div>
            <div class="info-section">
              <h5>📦 Where Do They Get Your Info?</h5>
              <p>
                Your data can come from surprising and seemingly harmless
                places:
              </p>
              <ul>
                <li>
                  <b>Public Records</b><br />Property ownership, voter
                  registrations, court filings, marriage licenses, etc.
                </li>
                <li>
                  <b>Online Activity</b><br />Browsing habits, purchases,
                  clicks, search history — often tracked via cookies and
                  third-party trackers.
                </li>
                <li>
                  <b>Apps & Services</b><br />Many “free” apps and websites sell
                  user data to data brokers as part of their monetization
                  strategy.
                </li>
                <li>
                  <b>Social Media</b><br />Even if your profiles are private,
                  your interactions and public posts can be scraped or inferred.
                </li>
                <li>
                  <b>Retail Loyalty Programs</b><br />Supermarket and store
                  rewards programs often share or sell your purchasing behavior.
                </li>
                <li>
                  <b>Surveys & Sweepstakes</b><br />Filling out forms or
                  entering giveaways? That data often ends up in broker
                  databases.
                </li>
              </ul>
            </div>
            <div class="info-section">
              <h5>💡 What Do They Know About You?</h5>
              <p>
                A lot more than you'd expect. Depending on the broker, your
                profile may include:
              </p>
              <ul>
                <li>Full name, age, gender</li>
                <li>Current and past addresses</li>
                <li>Phone numbers and email addresses</li>
                <li>Education and employment history</li>
                <li>Family members and relationships</li>
                <li>Estimated income, spending habits, interests</li>
                <li>Political or religious affiliations</li>
                <li>Even predictions about your behavior or lifestyle</li>
              </ul>
            </div>
            <div class="info-section">
              <h5>😠 Why This Matters</h5>
              <ul>
                <li>
                  It
                  <b
                    >increases your exposure to spam, scams, and identity
                    theft</b
                  >
                </li>
                <li>
                  It can lead to <b>unfair discrimination</b> in credit,
                  housing, or job opportunities
                </li>
                <li>
                  It often happens <b>without your knowledge or consent</b>
                </li>
              </ul>
              <p>
                You didn’t ask for this — but it’s happening behind the scenes,
                every day.
              </p>
            </div>
            <div class="info-section">
              <h5>✅ What You Can Do About It</h5>
              <p>That’s where we come in.</p>
              <p>
                We contact data brokers <b>on your behalf</b> to demand removal
                of your personal information. Then we keep checking back —
                because many brokers re-add you over time.
              </p>
              <p>
                You have the right to <b>privacy</b> — and it starts by holding
                data brokers accountable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
